module.exports = __webpack_public_path__ + "img/instructor_img2.49d69b92.png";